import React, {useContext} from 'react';
import UserContext from '../../common/UserContext';

import {Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import {Button} from '@progress/kendo-react-buttons';

import {useLocalization} from '@progress/kendo-react-intl';
import {
    areYouSureKey,
    cancelKey,
    confirmKey,
    mainMessages,
    changesLostKey,
} from '../../../assets/text/MultilingualText';

const DiscardChangesModal = (props) => {
    const {
        setIsVisible,
        discardChanges,
    } = props;

    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const localization = useLocalization();

    const closeModal = () => {
        setIsVisible(isVisible => ({...isVisible, discardChangesModal: false}));
    };

    return (
        <Dialog
            className={'ksm-dialog'}
            title={localization.toLanguageString(areYouSureKey, mainMessages[siteLanguageDefault][areYouSureKey])}
            onClose={closeModal}
            width={'32rem'}
        >
            <div style={{fontSize: '1rem'}}>
                {localization.toLanguageString(changesLostKey, mainMessages[siteLanguageDefault][changesLostKey])}
            </div>
            <DialogActionsBar layout={'center'}>
                <Button
                    themeColor={'primary'}
                    size={'large'}
                    fillMode={'outline'}
                    type={'button'}
                    onClick={closeModal}
                >
                    {localization.toLanguageString(cancelKey, mainMessages[siteLanguageDefault][cancelKey])}
                </Button>
                <Button
                    themeColor={'primary'}
                    size={'large'}
                    fillMode={'solid'}
                    type={'button'}
                    onClick={discardChanges}
                >
                    {localization.toLanguageString(confirmKey, mainMessages[siteLanguageDefault][confirmKey])}
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
};

export default DiscardChangesModal;
